import React, { useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import gsap from "gsap";
import "./PC.css";

function PC() {
  const workspaceRef = useRef(null);
  const booksRef = useRef(null);

  useEffect(() => {
    // Animate workspace card from left
    gsap.from(workspaceRef.current, {
      x: -100,
      opacity: 0,
      duration: 1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: workspaceRef.current,
        start: "top 80%",
      },
    });

    // Animate books card from right
    gsap.from(booksRef.current, {
      x: 100,
      opacity: 0,
      duration: 1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: booksRef.current,
        start: "top 80%",
      },
    });

    // Hover effect on workspace image
    gsap.to(workspaceRef.current, {
      scale: 1.02,
      duration: 0.5,
      ease: "power1.inOut",
      scrollTrigger: workspaceRef.current,
    });
  }, []);

  const books = [
    { title: "Atomic Habits", year: 2025 },
    { title: "Steal Like An Artist", year: 2024 },
    { title: "Ikigai", year: 2023 },
    { title: "Wings Of Fire", year: 2020 },
  ];

  return (
    <section className="pc-section" style={{ padding: "60px 20px" }}>
      <Container>
        <div className="pc-grid">
          {/* Workspace Card */}
          <div ref={workspaceRef} className="pc-card pc-left">
            <h3 className="pc-title">My Workspace</h3>
            <p style={{textAlign:"center", color:"white"}}>I spend most of my time here</p> 
            <img
              src="images/img-skills.avif"
              alt="Workspace"
              className="pc-image"
            />
          </div>

          {/* Books Card */}
          <div ref={booksRef} className="pc-card pc-right">
            <h3 className="pc-title">Books I've Read</h3>
            <ul className="books-list">
              {books.map((book, i) => (
                <li key={i} className="book-item">
                  {book.title} <span className="book-year">({book.year})</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default PC;
